import {Component, ViewEncapsulation} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';

export const DEFAULT_HEADER_OFFSET: number = 70;

@UntilDestroy()
@Component({
    selector: 'dcp-search-sorting',
    templateUrl: './search-sorting.component.html',
    styleUrls: ['./search-sorting.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SearchSortingComponent {}
